<template>
  <div>
    <div
      v-for="[serviceId, notifications] in Object.entries(servicesMappedToNotifications)"
      :key="serviceId"
    >
      <b-row>
        <b-col cols="12" lg="10" xl="6">
          <h3>
            {{ getServiceName(serviceId) }}
            <small class="float-right">{{ getServiceById(serviceId).fullName }}</small>
          </h3>
          <notifications-list
            :notifications="notifications"
            class="mt-3"
            :collapsed="true"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NotificationsList from '@/components/notifications/settings/List';
import BreadcrumbsManager from '@/mixins/BreadcrumbsManager';


export default {
  name: 'Notifications',
  mixins: [
    BreadcrumbsManager,
  ],
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$t('notifications'),
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'getServiceById',
      'getServiceName',
    ]),
    ...mapGetters('notifications', [
      'getEnabledNotifications',
    ]),
    servicesMappedToNotifications() {
      const mappings = {};
      this.getEnabledNotifications.forEach((n) => {
        if (mappings[n.service] === undefined) {
          mappings[n.service] = [n];
        } else {
          mappings[n.service].push(n);
        }
      });
      console.log(mappings);
      return mappings;
    },
  },
  components: {
    NotificationsList,
  },
};
</script>

<style scoped>

</style>
